/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import Icon from "./ui/Icon";
import Text from "./ui/Text";
import styled from "styled-components";

const EmptyViewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 2rem;
  gap: 1.5rem;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const EmptyView = ({
  icon: IconProp,
  title,
  description,
  action,
  size = Icon.SIZE.XL,
  iconColor = "primary",
  ...props
}) => {

  return (
    <EmptyViewWrapper {...props}>
      {IconProp && <IconProp size={size} color={iconColor} />}
      <TextWrapper>
        {title && <Text size="large" color="dark" weight="bold">{title}</Text>}
        {description && <Text>{description}</Text>}
      </TextWrapper>
      {action}
    </EmptyViewWrapper>
  );
};

export default EmptyView;